namespace AgerLMS.LMS {
    export interface DocumentOrderRequest extends Serenity.ServiceRequest {
        Source?: LmsDocumentRow;
        Target?: LmsDocumentRow;
    }
}
